type DebounceLeadingOptions = { leading: true; trailing?: false }
type DebounceTrailingOptions = { leading?: false; trailing: true }
type DebounceBothOptions = { leading: true; trailing: true }
type DebounceOptions = DebounceLeadingOptions | DebounceTrailingOptions | DebounceBothOptions

export type Debounced<T> = T & { cancel: () => void }

export function debounce<T extends (...args: never[]) => void>(
  fn: T,
  delay: number,
  { leading = false, trailing = true }: DebounceOptions = { trailing: true },
): Debounced<T> {
  let timeoutID: ReturnType<typeof setTimeout> | undefined
  const debounced = function (this: never, ...args: never[]) {
    const callNow = leading && !timeoutID
    clearTimeout(timeoutID)
    timeoutID = setTimeout(() => {
      timeoutID = undefined
      if (trailing) {
        fn.apply(this, args)
      }
    }, delay)
    if (callNow) {
      fn.apply(this, args)
    }
  } as Debounced<T>
  debounced.cancel = () => {
    clearTimeout(timeoutID)
    timeoutID = undefined
  }
  return debounced
}
